import React, { useEffect, useState } from 'react';

const SIZES = [
  { key: 'small', label: 'A', size: 11 },
  { key: 'medium', label: 'A', size: 13 },
  { key: 'large', label: 'A', size: 16 },
];

const applyFontSize = (size) => {
  document.body.classList.remove('font-small', 'font-medium', 'font-large');
  document.body.classList.add(`font-${size}`);
};

const initialSize = () => {
  try { return localStorage.getItem('fontSize') || 'medium'; }
  catch { return 'medium'; }
};

// Apply on module load so the class is set before any component mounts
applyFontSize(initialSize());

const FontSizeSwitcher = ({ compact = false }) => {
  const [size, setSize] = useState(initialSize);

  useEffect(() => {
    applyFontSize(size);
    try { localStorage.setItem('fontSize', size); } catch {}
  }, [size]);

  return (
    <div style={{ display: 'flex', gap: 2, alignItems: 'center', border: '1px solid #e5e7eb', borderRadius: 8, padding: 2, background: '#fff' }}>
      {SIZES.map(s => (
        <button
          key={s.key}
          onClick={() => setSize(s.key)}
          title={s.key.charAt(0).toUpperCase() + s.key.slice(1)}
          style={{
            padding: compact ? '2px 8px' : '4px 10px',
            fontSize: s.size,
            border: 'none',
            borderRadius: 6,
            background: size === s.key ? '#4f46e5' : 'transparent',
            color: size === s.key ? '#fff' : '#6b7280',
            cursor: 'pointer',
            fontWeight: 700,
            lineHeight: 1,
            minWidth: 22,
          }}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
};

export default FontSizeSwitcher;
